import * as Yup from 'yup';
import { Steps } from './types';

export const shipmentSchema = Yup.object({
    shipmentId: Yup.string().nullable().required(),
});

export const formSchema = Yup.object({
    formType: Yup.string().nullable().required(),
});

export const customerSchema = Yup.object({
    customerId: Yup.string().nullable().required(),
});

export const templateSchema = Yup.object({
    templateId: Yup.string().nullable().required(),
});

export const shipmentDetailsSchema = Yup.object({
    carrier: Yup.string().nullable().required(),
    countryOriginCode: Yup.string().nullable().required(),
    entryCountryCode: Yup.string().nullable().required(),
    destinationCode: Yup.string().nullable().required(),
    eta: Yup.string().nullable().required(),
});

export const bulkSubmissionSchema = Yup.object({
    s3Link: Yup.string().nullable().required(),
});

export const shipmentFormValidationSchema = Yup.object({
    [Steps.SHIPMENT]: shipmentSchema,
    [Steps.FORM]: formSchema,
    [Steps.CUSTOMER]: customerSchema,
    [Steps.TEMPLATE]: templateSchema,
    [Steps.SHIPMENT_DETAILS]: shipmentDetailsSchema,
    [Steps.BULK_SUBMISSION]: bulkSubmissionSchema,
});
